const demandsType = [
  {text: 'Nuova', value: 'NEW'},
  {text: 'Aggiornamento', value: 'UPDATE'},
  {text: 'Aggiornamento', value: 'ADMIN_UPDATE'},
  {text: 'Riemissione', value: 'REISSUE'}
]
export default demandsType
